@import (reference) '../../../../../../constants/spacing.module.less';

.icon {
  margin: @space-24 auto @space-24 0;
  height: 50px;
}

.storeLabel {
  margin-bottom: @space-24;
}

.authenticationSteps {
  > li {
    margin-bottom: @space-8;
  }
}

.step3 {
  margin-bottom: @space-24;
}

.shopifyAdditionalInfoSection {
  margin-top: @space-24;
  padding: @space-16;
}

.cardHeader {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.caret {
  height: 12px;
  width: 12px;
}

.expandedInformation {
  padding: 0 @space-16;

  li {
    display: list-item;
    font-size: 14px;
    list-style: auto;
    list-style-type: disc;
    margin-bottom: @space-8;
  }
}
